import { Environment } from './environment.interface';

export const environment: Environment = {
  name: 'staging',
  production: 'false',
  apiUrl: 'https://staging-content-service.everydayspeech.com/',
  learningServiceBaseUrl: 'https://staging-learning.everydayspeech.com',
  appId: 'QPqBtJFqwkoFFr7tk2Fk2F0BFap0Bq37tQdT7tLQ9g',
  cloudinaryUrl: 'https://api.cloudinary.com/v1_1/everyday-speech/upload',
  selCurriculumSlug: 'social-emotional-learning',
  scCurriculumSlug: 'social-communication-skills',
  unifiedCurriculumSlug: 'unified-curriculum',
  ddApplicationId: '6058a9ce-550a-4880-931a-9f875e5276f5',
  ddToken: 'pub69c1757964326395193787f77baab7ff',
  ddServiceName: 'slp-cms-staging',
  ddEnv: 'staging',
  posthogApiKey: 'phc_mywIlTmCSkSZxQCi3Sxz7kTcp4MWuzPsqvT5Ez6VCVy',
  posthogApiHost: 'https://d1j1m37vtn36nh.cloudfront.net',
};
